import React from 'react';
import Anime from 'react-anime';
import { isBrowser } from 'react-device-detect';
import './RandomCircles.scss';
import {
  getRandomRadius,
} from './_utils';

export default () => {
  const circlesList = [
    {},{},{},{},{}, // 10
  ];

  const positions = [
    ['10vw', '2vh'],
    ['30vw', '10vh'],
    ['66vw', '90vh'],
    ['90vw', '80vh'],
    ['75vw', '1vh'],
  ]
  const animateCircles = {
    top: [
      { value: (el, i) => positions[i][1], easing: 'easeInOutElastic', duration: 0}
    ],
    left: [
      { value: (el, i) => positions[i][0], easing: 'easeInOutElastic', duration: 0}
    ],
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 500, delay: 2000, easing: 'linear'}
    ]
  };

  const dropSingle = {
    top: [
      { value: () => '110%', duration: 1200, easing: 'easeInSine'},
    ],
    left: [
      { value: () => 'auto', duration: 0, delay: 1000},
    ],
  }

  const enlargeCircle = {
    scale: [
      { value: 0, duration: 0},
      { value: 1, duration: 500, easing: 'linear', delay: 2000}
    ]
  }

  const CreateCircles = () => (
    <div className="random-circles">
      <div className="circle-container">
        <Anime {...animateCircles}>
          {circlesList && circlesList.map((circle, i) => {
            let max = isBrowser ? 120 : 100;
            let radius = getRandomRadius(max);
            return (
              <div key={`${i}-1`} className={`circle-cover circle-cover-${i}`}>
                <div style={{width: radius[0], height: radius[0]}}></div>
              </div>
            );
          })}
        </Anime>
        <Anime {...enlargeCircle} className="random-image-circle random-image-circle--doctor"></Anime>
        <Anime {...enlargeCircle} className="random-image-circle random-image-circle--lab"></Anime>
        <Anime {...dropSingle} className="single-ball">
          <div></div>
        </Anime>
      </div>
    </div>
  );
  return <CreateCircles />
};